import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {activarUsuario, getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_heomoney/helpers'
import {useAuth} from '../core/Auth'
import {useIntl} from 'react-intl'
import {Button, Modal} from 'react-bootstrap'

import {sha256} from 'js-sha256'

import {AuthModel} from '../core/_models'
import Swal from 'sweetalert2'

const initialValues = {
  email: '',
  password: '',
}

type Props = {
  onContinue: () => void
}

let inputvalor = ''
let email = ''
let autha: AuthModel

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/
const ExampleModal = ({onContinue}: Props) => {
  const [showModal, setShowModal] = useState(true)
  const [valor, setValor] = useState('')

  const handleClose = () => {
    setShowModal(false)
    inputvalor = valor
    onContinue()
  }

  const tenervalor = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValor(e.target.value)
  }

  return (
    <Modal show={showModal} onHide={handleClose} centered backdrop='static'>
      <Modal.Header>
        <h2 className='text-center'>Bienvenido</h2>
      </Modal.Header>
      <Modal.Body>
        Para continuar ingrese el código de activación que envíamos a su correo
        <input className='form-control bg-transparent mt-5' value={valor} onChange={tenervalor} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          Continuar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export function Login() {
  //Para mostrar "Continue" si es false o "Espere por favor" si es verdadero
  const [loading, setLoading] = useState(false)
  const [showModalActive, setShowModalActive] = useState(false)
  const [msg, setMsg] = useState('')
  const {saveAuth, setCurrentUser, currentUser} = useAuth()
  const intl = useIntl()
  const [emails, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [autha, setAutha] = useState<AuthModel>()
  //Con esta propiedad de intl traemos el idioma actual
  // console.log(intl.locale)
  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILFORMAT'}))
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILREQUIRED'})),
    password: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDREQUIRED'})),
  })

  const waitForModalClose = (): Promise<void> => {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (!showModalActive) {
          clearInterval(interval)
          resolve()
        }
      }, 100)
    })
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleContinue = async () => {
    console.log('se cerró el modal')
    console.log(email)
    console.log(inputvalor)
    const {data: activate} = await activarUsuario(email, inputvalor, intl.locale.toUpperCase())
    console.log(activate)
    // console.log(inputvalor);
    // console.log(email);
    if (activate.msg_id == '0') {
      const {data: auth1} = await login(
        email,
        sha256(process.env.REACT_APP_SALT + sha256(pass)),
        // 'frontOffice',
        'backOffice',
        intl.locale.toUpperCase()
      )
      saveAuth(auth1)
      const {data: user} = await getUserByToken(auth1.w_Token, 'backOffice')
      setCurrentUser(user)
      setMsg(autha?.msg_txt || '')
    } else if (activate.msg_id == '1') {
      // console.log(activate)

      Swal.fire({
        icon: 'error',
        title: 'Oops... Ocurrio un error',
        text: `${activate.msg_txt}`,

        timer: 3000,
      })
      setShowModalActive(false)
      // alert(activate.msg_txt)
      // window.location.reload()
    }
  }
  //auth.id_msg=="0"
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      // try {
      //   //TRAER EL TOKEN
      //   const {data: auth} = await login(values.email, values.password)
      //   //GUARDAR EL TOKEN
      //   saveAuth(auth)
      //   //TRAER EL USUARIO SEGUN EL TOKEN
      //   const {data: user} = await getUserByToken(auth.api_token)
      //   //GUARDAR EL USUARIO
      //   setCurrentUser(user)
      // }catch (error) {
      //   //Para mostrar el error en consola
      //   console.error(error)
      //   saveAuth(undefined)
      //   //El estado del formulario y se muestra como "bienvenida" o "credenciales incorrectas"
      //   setStatus(intl.formatMessage({id: 'VALIDATION.LOGINCREDENTIALS'}))
      //   //No hará acciones el botón
      //   setSubmitting(false)
      //   //El boton "Continuar" no va a mostrar "Por favor espere"
      //   setLoading(false)
      // }

      //GUARDAR EL TOKEN

      try {
        console.log(sha256(process.env.REACT_APP_SALT + sha256(values.password)))
        //console.log(sha256(process.env.REACT_APP_SALT + sha256("hola2")));
        const {data: auth} = await login(
          values.email,
          sha256(process.env.REACT_APP_SALT + sha256(values.password)),
          // 'frontOffice',
          'backOffice',
          intl.locale.toUpperCase()
        )
        // localStorage.setItem('tiempo_expiracion','10')
        setEmail(values.email)
        setPass(values.password)
        email = values.email
        console.log(auth)
        saveAuth(auth)

        // //CAMINO EXITOSO DE LOGIN
        // console.log(values.email);
        if (auth.msg_id == '0') {
          //Evaluar si tiene código en la base de datos
          // const {data: Register} = await validateActive(values.email)
          // console.log(Register.txt_msg);
          // if (Register.id_msg == '0') {
          //   console.log(envio)
          //   setAutha(auth)
          //   setShowModalActive(true)
          // } else {
          console.log(auth.msg_txt)
          const {data: user} = await getUserByToken(auth.w_Token, 'backOffice')
          setCurrentUser(user)
          console.log(user)
          setLoading(false)

          //   setMsg(auth.message)
          // }

          // Mostrar mensaje de usuario autorizado
        } else if (auth.msg_id == '1') {
          // console.log(envio);
          saveAuth(undefined)
          setStatus(auth.msg_txt)
          setMsg(auth.msg_txt)
          setSubmitting(false)
          setLoading(false)
          // setTimeout(() => {
          //   window.location.reload()
          // }, 3000);

          // Mostrar mensaje de usuario no autorizado
        } else if (auth.msg_id == '2') {
          //Evaluar si tiene código en la base de datos
          // const {data: Register} = await validateActive(values.email)
          // console.log(Register.txt_msg);
          // if (Register.id_msg == '0') {
          // console.log(envio)
          setAutha(autha)
          setShowModalActive(true)
          // } else {
          //   saveAuth(auth)
          // //   const {data: user} = await getUserByToken(auth.token.acces_Token)
          //   setCurrentUser(auth)
          //   setMsg(auth.message)
          // }
        }
        // setTimeout(() => {
        //   saveAuth(undefined)
        //   setCurrentUser(undefined)
        // }, 10000);
      } catch (error) {
        console.log('el error')
        console.error(error)
      }
      setLoading(false)
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={(e) => {
        formik.handleSubmit(e)
        // ;
        // sendEmail(e)
      }}
      noValidate
      id='kt_login_signin_form'
    >
      {/* {/ begin::Heading /} */}

      {/* <div className='text-center mb-1'>
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id: 'LOGIN.TITLE'})}</h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          {intl.formatMessage({id: 'LOGIN.TEXT2'})}
        </div>
      </div> */}
      <div className='text-center mb-1'>
        <img src={toAbsoluteUrl('/media/logos/logo.webp')} className='h-100px' />
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id: 'LOGIN.TITLE'})}</h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          {/* {intl.formatMessage({id: 'LOGIN.TEXT2'})} */}
        </div>
      </div>

      {/* {/ begin::Heading /} */}
      {/* <ModalActive
        show={showModalActive}
        text='Para continuar, ingrese el código de activación que eniamos a su correo'
        
      /> */}
      {showModalActive && <ExampleModal onContinue={handleContinue} />}
      {/* {/ begin::Login options /} */}

      {/* <div className='row g-3 mb-9'>

        <div className='col-md-6'>

          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            {intl.formatMessage({id: 'LOGIN.GOOGLE'})}
          </a>
         
        </div>

        <div className='col-md-6'>
       
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            {intl.formatMessage({id: 'LOGIN.APPLE'})}
          </a>
         
        </div>
      
      </div> */}

      {/* {/ end::Login options /} */}

      {/* {/ begin::Separator /} */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>
          {intl.formatMessage({id: 'LOGIN.TEXT3'})}
        </span>
      </div> */}
      {/* {/ end::Separator /} */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>{intl.formatMessage({id: 'LOGIN.WELLCOME'})}</div>
        </div>
      )}

      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>

      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>
          {intl.formatMessage({id: 'LOGIN.TEXT.LABELCONTRASEÑA'})}
        </label>

        {/* <input
          type='password'
          placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELCONTRASEÑA'})}
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />

        
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )} */}
        <div className='input-group position-relative'>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELCONTRASEÑA'})}
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx('form-control bg-transparent rounded h-40px', {
              'is-invalid': formik.touched.password && formik.errors.password,
              'is-valid': formik.touched.password && !formik.errors.password,
            })}
          />
          <button
            className='btn btn-primary px-2 border border-1 border-gray-400 position-absolute end-0 h-40px'
            type='button'
            onClick={handleTogglePasswordVisibility}
            style={{zIndex: 5}}
          >
            {showPassword ? (
              <div className='w-100 h-100 d-flex align-items-center'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='w-25px h-25px'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
                  />
                </svg>
              </div>
            ) : (
              <div className='w-100 h-100 d-flex align-items-center '>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='w-25px h-25px'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
                  />
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
                  />
                </svg>
              </div>
            )}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        {/* {/ <Link to='/auth/forgot-password-copia' className='link-primary'> /} */}
        <Link to='/auth/forgot-password' className='link-primary'>
          {intl.formatMessage({id: 'LOGIN.FORGOTPASSWORD'})}
        </Link>
      </div>

      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
          onClick={() => {
            setShowModalActive(showModalActive)
          }}
        >
          {!loading && (
            <span className='indicator-label'>{intl.formatMessage({id: 'LOGIN.BTNTEXT'})}</span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'LOGIN.BTNWAIT'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        {intl.formatMessage({id: 'LOGIN.TEXT.NOTMEMBER'})}{' '}
        <Link to='/auth/registration' className='link-primary'>
          {intl.formatMessage({id: 'AUTH.GENERAL.SIGNUP_BUTTON'})}
        </Link>
      </div> */}
    </form>
  )
}
